"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ShowIcon = function ShowIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 7.5C8.63167 7.5 7.5 8.6325 7.5 10C7.5 11.3683 8.63167 12.5 10 12.5C11.3675 12.5 12.5 11.3683 12.5 10C12.5 8.6325 11.3675 7.5 10 7.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.99992 4.16675C3.63908 4.16675 1.72742 9.68092 1.70992 9.73675L1.62158 10.0001L1.70908 10.2634C1.72742 10.3192 3.63908 15.8334 9.99992 15.8334C16.3607 15.8334 18.2724 10.3192 18.2899 10.2634L18.3783 10.0001L18.2907 9.73675C18.2724 9.68092 16.3607 4.16675 9.99992 4.16675ZM9.99992 14.1667C5.54075 14.1667 3.81325 10.9617 3.39492 10.0001C3.81492 9.03508 5.54325 5.83341 9.99992 5.83341C14.4591 5.83341 16.1866 9.03842 16.6049 10.0001C16.1849 10.9651 14.4566 14.1667 9.99992 14.1667Z",
    fill: color
  }));
};

var _default = ShowIcon;
exports.default = _default;